import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const photos = [
  { alt: "Remplacement de moteur de volet roulant à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg" },
  { alt: "Réparation de sangle de volet roulant dans le Bas-Rhin", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg" },
  { alt: "Technicien réparant un tablier de volet roulant à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg" },
  { alt: "Diagnostic d'un volet roulant électrique à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg" },
  { alt: "Remplacement de cordon de volet roulant en urgence", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg" },
  { alt: "Réparation de volet roulant après une tentative d'effraction à Strasbourg", src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg" },
];

export default function Galerie() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Nos réalisations de réparation
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {photos.map((p) => (
            <div key={p.alt} className="relative rounded-xl overflow-hidden border border-brand-border aspect-[4/3] bg-white">
              <ImagePlaceholder
                src={p.src}
                alt={p.alt}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}